import { api } from "@vuumly-common/common";

export const getEndpoint = (endpoint: api.Endpoint) => {
  return `${process.env.REACT_APP_DATA_API_ENDPOINT}/v1/${endpoint}`;
}